import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import moment from 'moment';
import JisTabButton from '../../components/controls/jisTabButton';
import NewGif from '../../assets/new_icon.gif';
import JisDialogForm from '../../components/formdialog';
function GeneralCases() {
  const FeeTYPEID=31; //this supose to be review fee
     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData, setIsExpired} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
        const [count, setCount] = useState(0);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState({});
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [previewUrl, setPreviewUrl] =  useState(false);
     const [isGazette, setIsGazette] = useState(false);
     const [active, setActive] =useState(null);
     const [index, setIndex] = useState(-1);
     const [openCase,setOpenCase] =useState(false);

      useEffect(() => {
          onLoad();       
    }, []);

    useEffect(() => {
      if(!isSearch){
        onLoad(); 
      }else{
        onSearch(search);
      }
                
    }, [pageIndex,pageSize,search]);

  const onSearch=async(sear)=>{ 
            
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/report/general-cases/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
            } else if(data.code==-10){
                      setIsExpired(true);
                  }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

const onLoad= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/report/psa-cases/${pageIndex}/${pageSize}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setCases(data.items)
              if(pageIndex==0){
                setCount(data.totalCount);
              } 
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }


const onCloseOpenCase=()=>{
  setActive(null);
  setIndex(-1);
  setOpenCase(false);
}



 const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
}

const onDirectSearch=(sear)=>{
   setSearch(sear)       ;
   setIsSearch(true);
  setPageIndex(0);
}
  const onContinue=(fee,ind)=>{
        //navigate(`/case-details/${caseid}`)
        setActive(fee);
        setIndex(ind);
        setOpenCase(true);
    }
  return (
    <div>
      
      <CaseSearch onSearch={onDirectSearch} frequentData={frequentData} />



<div className='table'>
  <div class="section-cases">
  <span> Case Search</span>
</div>
      <table class="case-table">
  <thead>
    <tr>
      <th>Suit Number</th>
      <th>Case Title</th>
      <th>Filing Type</th>
      <th>Classification</th>
      <th>Date Filed</th>
      <th>Status Level</th>
      <th>View</th>
    </tr>
  </thead>
  <tbody>
     {cases?.map((opt, index) => (
       <tr key={index}>
      <td style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.colour}`}}> {opt.caseNumber?? opt.referenceNumber}</td>
      <td>{opt.caseTitle}</td>
       <td>{Constants.getItemById(frequentData?.casetype,opt.caseTypeId)?.caseType1}</td>
      <td> {Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.categoryTitle}</td>
      <td> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
      <td>{Constants.getItemById(frequentData?.casestatuses,opt.caseStatusId)?.description} </td>
       <td><JisButton  variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
    </tr>
    ))} 
    


  </tbody>
   {cases?.length>0 && <Pagenated size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
</table>
</div>
<BackLoader open={loading} />

  
         
          {openCase && active!=null  && <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails  caseId={active.caseId} data={null} token={token} />
          </div>
</JisDialogForm>} 
    </div>
  );
}
export default GeneralCases;